module.exports = __webpack_public_path__ + "dist/assets/c74bc77f5a3608d1bea8e351a2b9f0c9.svg";